/**
 * The rail's quick menus (help, account) share one look: a soft popover of
 * roomy rows, an icon on the left, a hint on the right, staggered in.
 *
 * @module components/ui/quick-menu
 */
import type { ComponentProps, ReactNode } from "react";

import { cn } from "~/lib/utils";

export const QUICK_MENU_POPUP_CLASS = "w-72 rounded-xl";
export const QUICK_MENU_VIEWPORT_CLASS = "p-1.5 [--viewport-inline-padding:0px]";

export function QuickMenuRow({
  icon,
  hint,
  active = false,
  className,
  children,
  ...props
}: ComponentProps<"button"> & {
  readonly icon?: ReactNode;
  readonly hint?: ReactNode;
  readonly active?: boolean;
}) {
  return (
    <button
      type="button"
      data-active={active}
      className={cn(
        "quick-menu-row flex h-9 w-full cursor-pointer items-center gap-3 rounded-lg px-2.5 text-left text-[13px] font-medium text-popover-foreground outline-hidden transition-colors hover:bg-accent data-[active=true]:bg-accent disabled:cursor-default disabled:opacity-60",
        className,
      )}
      {...props}
    >
      {icon ? <span className="flex size-4 shrink-0 items-center justify-center text-muted-foreground [&_svg]:size-4">{icon}</span> : null}
      <span className="min-w-0 flex-1 truncate">{children}</span>
      {hint ? <span className="shrink-0 text-xs font-normal text-muted-foreground">{hint}</span> : null}
    </button>
  );
}

export function QuickMenuSeparator() {
  return <div role="separator" className="my-1.5 h-px bg-border/60" />;
}
